export const LOCATION_TYPES = ['domicile', 'travail', 'client', 'lieu_public', 'autre'] as const;
export type LocationType = typeof LOCATION_TYPES[number];
export type RuleOutcome = 'professional' | 'personal' | 'ask_driver';

export interface QualificationRule {
  _id: string;
  company_id: string | null;
  departure_type: LocationType;
  arrival_type: LocationType;
  outcome: RuleOutcome;
  is_active: boolean;
  source?: 'company' | 'global';
}
